import React, { useState } from 'react';
import { Box, Grid, Tab, Tabs } from '@mui/material';
import Layout from '../Layout/Layout';
import AudioWebSocket from './WebSocket/AudioWebSocket';
import AudioSummary from './AudioSummary';
import GenerateAudio from './GenerateAudio';
import AudioGenerated from './AudioGenerated';
import AutoRulesSettings from './AutoRulesSettings';
import AudioSettings from './AudioSettings';
import InworldSettings from './InworldSettings';
import BulkAudio from './BulkAudio';

/** The tabs of the page: the value (also the ending of the ids) and the text */
const TABS = [
    { value: 'test', label: 'בדיקת יצירה' },
    { value: 'bulk', label: 'הרצה מרוכזת' },
    { value: 'rules', label: 'כללי יצירה אוטומטית' },
    { value: 'google', label: 'הגדרות Google' },
    { value: 'inworld', label: 'הגדרות Inworld' },
];

const AudioPage = () => {
    const tools = [];
    const drawerTools = [];

    const [tab, setTab] = useState('test');

    const headerHeight = 50;
    const tabsHeight = 48;
    const panelHeight = `calc(100vh - ${headerHeight + tabsHeight}px)`;

    /** The panel of a tab. All the panels stay mounted, so what was typed or created is not lost when the tab is changed */
    const panel = (value, content) => (
        <Box
            role="tabpanel"
            id={`audio-panel-${value}`}
            aria-labelledby={`audio-tab-${value}`}
            hidden={tab !== value}
            sx={{ display: tab === value ? 'block' : 'none', height: panelHeight, overflow: 'auto' }}
        >
            {content}
        </Box>
    );

    return (
        <Layout tools={tools} drawerTools={drawerTools}>
            <Box sx={{ height: tabsHeight, borderBottom: 1, borderColor: 'divider', px: 2 }}>
                <Tabs value={tab} onChange={(event, value) => setTab(value)} variant="scrollable" scrollButtons="auto">
                    {TABS.map(({ value, label }) => (
                        // textTransform: the names Google and Inworld are not written in capital letters
                        <Tab key={value} value={value} label={label} id={`audio-tab-${value}`} aria-controls={`audio-panel-${value}`} sx={{ textTransform: 'none' }} />
                    ))}
                </Tabs>
            </Box>

            {panel('test', (
                <Grid
                    container
                    spacing={0}
                    style={{ minHeight: '100%' }}
                >
                    {/*<Grid item xs={1.7}>
                        <AudioSummary />
                    </Grid>

                    <Grid item xs={10.3}>
                        <AudioWebSocket />
                    </Grid>*/}
                    <Grid item xs={12} md={4} lg={3}>
                        <GenerateAudio />
                    </Grid>
                    <Grid item xs={12} md={8} lg={9}>
                        <AudioGenerated />
                    </Grid>
                </Grid>
            ))}
            {panel('bulk', <BulkAudio active={tab === 'bulk'} />)}
            {panel('rules', <AutoRulesSettings />)}
            {panel('google', <AudioSettings />)}
            {panel('inworld', <InworldSettings />)}
        </Layout>
    );
};

export default AudioPage;
